export function StatusView({ loading, error, message, onRetry }) {
  if (!loading && !error) return null;

  return (
    <div className="ai-auth-container">
      {loading && (
        <>
          <div className="ai-loader"></div>
          <p className="ai-auth-text">
            {message || "Loading..."}
          </p>
        </>
      )}

      {error && (
        <>
          <p className="ai-error-text">
            {message || "Something went wrong. Please try again."}
          </p>

          {onRetry && (
            <button className="ai-retry-btn" onClick={onRetry}>
              Retry
            </button>
          )}
        </>
      )}
    </div>
  );
};

